export default __webpack_public_path__ + "static/toolkitHomeVp6-f550245cc57e76b0aa4e6311dc31ecea.png";